type CircleProps = {
  size?: number
  strokeWidth?: number
}

export const NotStartedCircle = ({ size = 16, strokeWidth = 2 }: CircleProps) => {
  const center = size / 2
  const radius = center - strokeWidth / 2

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} role="img" aria-label="Not started circle">
      <circle cx={center} cy={center} r={radius} fill="none" stroke="currentColor" strokeWidth={strokeWidth} />
    </svg>
  )
}
